const isDevelopment = process.env.NODE_ENV === 'development';

// Utility to safely stringify objects, removing sensitive data
const safeStringify = (obj) => {
  if (typeof obj !== 'object' || obj === null) return String(obj);
  
  // Deep clone to avoid modifying original
  const sanitized = JSON.parse(JSON.stringify(obj));
  
  // List of keys to remove/mask
  const sensitiveKeys = ['_id', 'asset', 'imageUrl', 'url', 'apiKey', 'token'];
  
  const sanitize = (obj) => {
    if (typeof obj !== 'object' || obj === null) return;
    
    Object.keys(obj).forEach(key => {
      if (sensitiveKeys.includes(key)) {
        obj[key] = '[REDACTED]';
      } else if (typeof obj[key] === 'object') {
        sanitize(obj[key]);
      }
    });
  };
  
  sanitize(sanitized);
  return JSON.stringify(sanitized, null, 2);
};

// List of errors that should be suppressed in production
const suppressedErrorMessages = [
  'Invalid OAuth access token',
  'Error fetching user details',
  'Error fetching Instagram media',
  'Failed to fetch Instagram media'
];

// Simple logger utility that works in both client and server environments
const logger = {
  info: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[INFO]', ...args);
    }
  },
  warn: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args) => {
    // In production, only log critical errors that aren't related to Instagram
    if (process.env.NODE_ENV === 'production') {
      // Check if this is a suppressable error
      const errorString = args.map(arg => 
        typeof arg === 'string' ? arg : 
        arg instanceof Error ? arg.message : 
        JSON.stringify(arg)
      ).join(' ');
      
      // Skip known non-critical errors in production
      const shouldSuppress = suppressedErrorMessages.some(msg => errorString.includes(msg));
      if (shouldSuppress) {
        return; // Don't log this error in production
      }
    }
    
    console.error('[ERROR]', ...args);
  },
  debug: (...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('[DEBUG]', ...args);
    }
  }
};

export default logger; 